<div class="shift-validation-content">
  <p-card *ngIf="loadsSummary" header="Loads Summary">
    <div *ngIf="loading" class="centered">
      <i class="pi pi-spin pi-spinner"></i>
      Calculating...
    </div>
    <div class="p-grid" *ngIf="!loading">
      <div class="p-col-6">
        <p-card header="Inbound Loads">
          <p-table [value]="groupedProcessed" dataKey="id">
            <ng-template pTemplate="header">
              <tr>
                <th style="width: 3rem"></th>
                <th>Operation</th>
                <th>Loads</th>
                <th>Pieces</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-groupedProcessed let-expanded="expanded">
              <tr>
                <td>
                  <button type="button" pButton style="color:black" pRipple [pRowToggler]="groupedProcessed"
                    class="p-button-text" [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
                </td>
                <td>{{groupedProcessed.subInventory?.name || '[unknown operation type]' }}</td>
                <td>{{groupedProcessed.items.length}}</td>
                <td>{{groupedProcessed.piecesTotal}}</td>
              </tr>
            </ng-template>
            <ng-template pTemplate="rowexpansion" let-unloads>
              <tr>
                <td colspan="4">
                  <p-table [value]="unloads.items" [autoLayout]="true" dataKey="id">
                    <ng-template pTemplate="header">
              <tr>
                <th>Supplier Name</th>
                <th>BOL #</th>
                <th>Trailer #</th>
                <th>SCAC</th>
                <th>Qty</th>
                <th></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
              <tr>
                <td>{{ row.name }}</td>
                <td>{{ row.bolNumber }}</td>
                <td>{{ row.trailerNumber }}</td>
                <td>{{ row.carrierCode }}</td>
                <td>
                  {{ totalQuantity(row.lineItems) }}<i (click)="overlayToggle($event, row.lineItems)"
                    class="pi pi-info-circle"></i>
                </td>
                <td>
                  <a [routerLink]="['../../loads/inbound', row.id]" target="_blank">
                    <button pButton icon="pi pi-external-link" iconPos="right" type="button" label="Load"
                      class="p-button-primary">
                    </button>
                  </a>
                </td>
              </tr>

            </ng-template>
          </p-table>
          </td>
          </tr>
          </ng-template>
          </p-table>
        </p-card>
      </div>
      <div class="p-col-6">
        <p-card header="Shipped Loads">
          <p-table [value]="groupedShipped" dataKey="id">
            <ng-template pTemplate="header">
              <tr>
                <th style="width: 3rem"></th>
                <th>Operation</th>
                <th>Loads</th>
                <th>Pieces</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-groupedShipped let-expanded="expanded">
              <tr>
                <td>
                  <button type="button" pButton style="color:black" pRipple [pRowToggler]="groupedShipped"
                    class="p-button-text" [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
                </td>
                <td>{{groupedShipped.subInventory?.name || '[unknown operation type]'}}</td>
                <td>{{groupedShipped.items.length}}</td>
                <td>{{groupedShipped.piecesTotal}}</td>
              </tr>
            </ng-template>
            <ng-template pTemplate="rowexpansion" let-shipped>
              <tr>
                <td colspan="4">
                  <p-table [value]="shipped.items" [autoLayout]="true">
                    <ng-template pTemplate="header">
              <tr>
                <th>Customer</th>
                <th>Propak BOL #</th>
                <th>Trailer #</th>
                <th>SCAC</th>
                <th>Qty</th>
                <th>Customer Ref #</th>
                <th></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
              <tr>
                <td>{{ row.name }}</td>
                <td>{{ row.bolNumber }}</td>
                <td>{{ row.trailerNumber }}</td>
                <td>{{ row.carrierCode }}</td>
                <td>
                  {{ totalQuantity(row.lineItems) }}<i (click)="overlayToggle($event, row.lineItems)"
                    class="pi pi-info-circle"></i>
                </td>
                <td>{{ row.customerReferenceNumber }}</td>
                <td>
                  <a [routerLink]="['../../loads/outbound', row.id]" target="_blank">
                    <button pButton icon="pi pi-external-link" iconPos="right" type="button" label="Load"
                      class="p-button-primary">
                    </button>
                  </a>
                </td>
              </tr>
            </ng-template>
          </p-table>
          </td>
          </tr>
          </ng-template>
          </p-table>
        </p-card>
      </div>
      <div class="p-col-6">
        <p-card header="PreLoads">
          <p-table [value]="groupedPreLoaded" dataKey="id">
            <ng-template pTemplate="header">
              <tr>
                <th style="width: 3rem"></th>
                <th>Operation</th>
                <th>Loads</th>
                <th>Pieces</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-groupedPreLoads let-expanded="expanded">
              <tr>
                <td>
                  <button type="button" pButton style="color:black" pRipple [pRowToggler]="groupedPreLoads"
                    class="p-button-text" [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
                </td>
                <td>{{groupedPreLoads.subInventory?.name || '[unknown operation type]'}}</td>
                <td>{{groupedPreLoads.items.length}}</td>
                <td>{{groupedPreLoads.piecesTotal}}</td>
              </tr>
            </ng-template>
            <ng-template pTemplate="rowexpansion" let-preLoads>
              <tr>
                <td colspan="4">
                  <p-table [value]="preLoads.items" dataKey="id" [autoLayout]="true">
                    <ng-template pTemplate="header">
              <tr>
                <th>Customer Ref #</th>
                <th>Customer</th>
                <th>BOL #</th>
                <th>Trailer #</th>
                <th>SCAC</th>
                <th>Qty</th>
                <th></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
              <tr>
                <td>{{ row.customerReferenceNumber }}</td>
                <td>{{ row.name }}</td>
                <td>{{ row.bolNumber }}</td>
                <td>{{ row.trailerNumber }}</td>
                <td>{{ row.carrierCode }}</td>
                <td>{{ totalQuantity(row.lineItems) }}<i (click)="overlayToggle($event, row.lineItems)"
                    class="pi pi-info-circle"></i>
                </td>
                <td>
                  <a [routerLink]="['../../loads/outbound', row.id]" target="_blank">
                    <button pButton icon="pi pi-external-link" iconPos="right" type="button" label="Load"
                      class="p-button-primary">
                    </button>
                  </a>
                </td>
              </tr>
            </ng-template>
          </p-table>
          </td>
          </tr>
          </ng-template>
          </p-table>
        </p-card>
      </div>
    </div>
  </p-card>
  <p-overlayPanel #op [style]="{width: '450px'}" [showCloseIcon]="true" [dismissable]="true" appendTo="body">
    <ng-template pTemplate>
      <p-table class="centered overlay" [value]="lineItems">
        <ng-template pTemplate="header">
          <tr>
            <th>Product</th>
            <th>Quantity</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-lineItem>
          <tr>
            <td>{{getProduct(lineItem.productId) | async}}</td>
            <td>{{lineItem.quantity}}</td>
          </tr>
        </ng-template>
      </p-table>
    </ng-template>
  </p-overlayPanel>
</div>
